import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import React, { useState } from "react";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import type { IRaffleWinner } from "src/Types/module/raffleDraw/raffleDraw";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import GenerateWinnerModal from "./GenerateWinnerModal";
import WinnerTableRow from "./WinnerTableRow";

const WinnerList: React.FC = () => {
	const [pagination, setPagination] = useState({ limit: 10, skip: 0 });
	const [search, setSearch] = useState("");
	const [openModal, setOpenModal] = useState(false);

	const { data, isLoading } = useGetQueryWithTotal<IRaffleWinner[]>({
		endPoint: "/api/raffle-draw/winner",
		queryKeys: ["raffle-winner", search, pagination.skip, pagination.limit],
		params: {
			...pagination,
			search: search || undefined,
		},
	});

	return (
		<>
			<CommCard
				showCardHeader
				headerTitle={`Winner List (${data?.total || 0})`}
				helmetTitle="BTTF - Raffle Draw Winner List"
				showButton
				btnText="Draw Winner"
				handleBtnForModalFun={() => setOpenModal(true)}
				showSearch
				handleSearchFun={(val) => {
					setSearch(val);
					setPagination((prev) => ({ ...prev, skip: 0 }));
				}}
			>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>SL.</TableCell>
								<TableCell>Prize</TableCell>
								<TableCell>Raffle No.</TableCell>
								<TableCell>Winner</TableCell>
								<TableCell>Contact</TableCell>
								<TableCell>User Type</TableCell>
								<TableCell>Prize Given</TableCell>
								<TableCell>Won At</TableCell>
								<TableCell>Actions</TableCell>
							</TableRow>
						</TableHead>

						{isLoading ? (
							<TableLoader />
						) : data?.data && data.data.length > 0 ? (
							<TableBody>
								{data.data.map((winner, idx) => (
									<WinnerTableRow
										key={winner.id}
										winner={winner}
										serial={idx + 1 + pagination.skip}
									/>
								))}
							</TableBody>
						) : (
							<TableNotFound />
						)}
					</Table>
				</TableContainer>

				<Box p={2}>
					<CommonPagination
						total={data?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>
			</CommCard>

			<ModalsWrapper
				showModal={openModal}
				setShowModal={setOpenModal}
				modalData={{ title: "Draw Raffle Winner" }}
				maxWidth="xs"
			>
				<GenerateWinnerModal handleClose={() => setOpenModal(false)} />
			</ModalsWrapper>
		</>
	);
};

export default WinnerList;
